import React from 'react'
import { Dropdown } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'
import i18n from '~/components/i18n'
import { useAuth } from '~/routes/components/AuthProvider'
import AuthService from '~/api/services/auth'
import notify from '../Notify'
import dayjs from 'dayjs'
import SupportService from '~/api/services/support'
import { FARMER_ROLE_SLUG } from '~/Constants'

const Languages: React.FC = () => {
  const { setSystemData, systemData, setSupportData, systemData: { logged: { roleSlug } } } = useAuth()
  const { t } = useTranslation()
  const language = systemData?.languages.find(language => language.id === systemData.logged.languageId)

  function getCorrectLanguageCode(languageCode) {
    switch (languageCode) {
      case 'gb':
        return 'en'
      case 'fr_BE':
      case 'fr_CH':
        return 'fr'
      case 'nl_BE':
        return 'nl'
      case 'de_CH':
        return 'de'
      default:
        return languageCode
    }
  }

  async function handleLanguageChange(languageId: number, languageCode: string) {
    try {
      await AuthService.languageUpdate(languageId)
      const correctLanguageCode = getCorrectLanguageCode(languageCode)
      dayjs.locale(correctLanguageCode)
      i18n.changeLanguage(languageCode)
      const response = await AuthService.getSystemData()
      if (roleSlug === FARMER_ROLE_SLUG) {
        const { data: supportData } = await SupportService.getSupport();
        setSupportData(supportData)
      }
      setSystemData({ ...response.data, openedLoginPopups: true })
    } catch (error) {
      if (error.response.data) {
        notify(error.response.data.message, 'error')
      } else {
        notify(t('General error'), 'error')
      }
    }
  }

  return <Dropdown
    icon={null}
    //@ts-ignore semantic type error
    trigger={<div style={{ color: 'white', fontWeight: 'bold' }}>
      {language?.label}
    </div>}
  >
    <Dropdown.Menu>
      {systemData?.languages.map(language => {
        return <Dropdown.Item
          key={language.id}
          value={systemData?.logged.languageId}
          text={language.label}
          onClick={() => handleLanguageChange(language.id, language.code)}
        />
      })}
    </Dropdown.Menu>
  </Dropdown>
}
export default Languages
